import { render, staticRenderFns } from "./RuleMinMax.vue?vue&type=template&id=3c817a06&scoped=true&"
import script from "./RuleMinMax.vue?vue&type=script&lang=ts&"
export * from "./RuleMinMax.vue?vue&type=script&lang=ts&"
import style0 from "./RuleMinMax.vue?vue&type=style&index=0&id=3c817a06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c817a06",
  null
  
)

export default component.exports